<template>
  <div class="document-container" style="padding-top: 10">
    <div
      v-if="this.hasVerified && this.step === 1"
      class="is-flex padding-top justify-content-center is-fullHeight">
      <div class="content has-text-center">
        <h4>Create your account</h4>
        <div class="reset-container-p4-round-white">
          <img src="@/assets/eScholar-logo-color.png" alt="eScholar Uniq-ID" width="50" height="50" />
          <form>
            <div class="field">
              <div class="field-body">
                <div class="field has-text-left">
                  <div class="control">
                    <label for="formCreateAccountEmail" class="label">Email Address</label>
                    <input
                      id="formCreateAccountEmail"
                      type="email"
                      class="input"
                      :class="{ 'is-danger': hasErrorEmail }"
                      v-model="email"
                      required
                      autofocus
                      @change.prevent="validate('email')"
                    />
                  </div>
                  <span v-if="hasErrorEmail" class="help is-danger">{{ emailMsg }}</span>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="field-body">
                <div class="field has-text-left">
                  <div class="control">
                    <label for="formCreateAccountFirstName" class="label">First Name</label>
                    <input
                      id="formCreateAccountFirstName"
                      class="input"
                      :class="{ 'is-danger': hasErrorFirstName}"
                      type="text"
                      v-model="firstname"
                      required
                      @change.prevent="validate('firstname')"
                    />
                  </div>
                  <span v-if="hasErrorFirstName" class="help is-danger">{{ fnMsg }}</span>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="field-body">
                <div class="field has-text-left">
                  <div class="control">
                    <label for="formCreateAccountMiddleName" class="label">
                      Middle Name
                      <span class="text-muted">(optional)</span>
                    </label>
                    <input
                      id="formCreateAccountMiddleName"
                      class="input"
                      :class="{ 'is-danger': hasErrorMiddleName}"
                      type="text"
                      v-model="middlename"
                      @change.prevent="validate('middlename')"
                    />
                  </div>
                  <span v-if="hasErrorMiddleName" class="help is-danger">{{ mnMsg }}</span>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="field-body">
                <div class="field has-text-left">
                  <div class="control">
                    <label for="formCreateAccountLastName" class="label">Last Name</label>
                    <input
                      id="formCreateAccountLastName"
                      class="input"
                      :class="{ 'is-danger': hasErrorLastName}"
                      type="text"
                      v-model="lastname"
                      required
                      @change.prevent="validate('lastname')"
                    />
                  </div>
                  <span v-if="hasErrorLastName" class="help is-danger">{{ lnMsg }}</span>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="field-body">
                <div class="field has-text-left">
                  <div class="control">
                    <label for="formCreateAccountDateOfBirth" class="label">
                      Date of Birth
                      <span class="text-muted">(optional)</span>
                    </label>
                    <input
                      id="formCreateAccountDateOfBirth"
                      class="input calendar"
                      :class="{ 'is-danger': hasErrorBirthDate}"
                      type="date"
                      v-model="birthdate"
                      @change.prevent="validate('birthdate')"
                    />
                  </div>
                  <span v-if="hasErrorBirthDate" class="help is-danger">{{ bdMsg }}</span>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="field-body">
                <div class="field has-text-left">
                  <div class="control">
                    <label for="formCreateAccountPhone" class="label">
                      Phone Number
                      <span class="text-muted">(optional)</span>
                    </label>
                    <input id="formCreateAccountPhone"
                      class="input"
                      :class="{ 'is-danger': hasErrorPhone}"
                      type="text"
                      v-model="phone"
                      @change.prevent="validate('phone')"/>
                  </div>
                  <span v-if="hasErrorPhone" class="help is-danger">{{ phoneMsg }}</span>
                </div>
              </div>
            </div>
            <div class="field">
              <button class="button is-primary is-fullwidth"
                @click.prevent="nextStep">
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-if="this.step === 2" class="is-flex padding-top justify-content-center is-fullHeight">
      <div class="content has-text-center">
        <h4>Hi {{this.formLogin.firstName}}, Please set your password.</h4>
        <p class="is-size-7 has-text-left">Follow these rules to create a strong password.</p>
        <ul class="content is-size-7 has-text-left">
          <li class="unstyled" v-for="rule in this.signUpRules" :key="rule.property">
            <span v-if="'true' === rule.active.toString()">
              <span v-if="failed.length" class="icon is-left">
                <font-awesome-icon v-if="ruleOk(rule)" :icon="['fas', 'check']"/>
                <font-awesome-icon v-else class="has-text-danger" :icon="['fas', 'ban']"/>
              </span>
              {{rule.message}}
            </span>
          </li>
        </ul>
        <div class="reset-container-p4-round-white">
          <div class>
            <img src="@/assets/eScholar-logo-color.png" alt="eScholar Uniq-ID" width="50" height="50" />
          </div>
          <form>
            <div class="field">
              <div class="field-body">
                <div class="field has-text-left">
                  <div class="control">
                    <label for="accountEmail" class="label">Email Address</label>
                    <input
                      id="accountEmail"
                      type="email"
                      class="input"
                      :class="{ 'is-danger': hasErrorEmail }"
                      v-model="this.formLogin.email"
                      disabled
                    />
                  </div>
                  <span v-if="hasErrorEmail" class="help is-danger">{{ emailMsg }}</span>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="field-body">
                <div class="field has-text-left">
                  <div class="control">
                    <label for="formCreateAccountPassword" class="label">Enter Password</label>
                    <input
                      id="formCreateAccountPassword"
                      type="password" autocomplete="off"
                      class="input"
                      :class="{ 'is-danger': hasErrorPassword }"
                      v-model="password"
                      required
                    />
                  </div>
                  <span v-if="hasErrorPassword" class="help is-danger">{{ pwMsg }}</span>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="field-body">
                <div class="field has-text-left">
                  <div class="control">
                    <label for="passwordConfirm" class="label">Verify Password</label>
                    <input
                      id="passwordConfirm"
                      type="password" autocomplete="off"
                      class="input"
                      :class="{ 'is-danger': hasErrorPassword }"
                      v-model.lazy="checkPassword"
                      required
                    />
                  </div>
                  <span v-if="hasErrorPassword" class="help is-danger">{{ pwMsg }}</span>
                </div>
              </div>
            </div>
            <div class="field">
              <button
                :disabled="loading"
                type="button"
                class="button is-primary is-fullwidth"
                @click.prevent="formSubmit">
                <span style="color:white;" v-if="loading">
                  <es-loader size="1x" :white="true"/>&nbsp;
                </span>
                {{ submitText }}
              </button>
            </div>
            <div class="field has-text-left">
              <a @click.prevent="prevStep"
                @keypress.enter.prevent="prevStep"
                tabindex="0"
                role="link"
              >
                &lt; Back to account details page
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
    <es-loader v-if="loading && !this.hasVerified"/>
    <div class="has-text-center" v-if="!loading && !this.hasVerified">
      <div class="no-result-container">
        <div class="icon">
          <font-awesome-icon :icon="['fal', 'exclamation-triangle']" size="4x"/>
        </div>
        <p></p>
        <h4>The link you used is invalid or expired.</h4>
        <h4>Please contact <a href="mailto:support@escholar.com">support@escholar.com</a>
          for additional information or help.</h4>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBan,
  faCheck,
} from '@fortawesome/pro-light-svg-icons';
import EmailUtils from '@/mixins/EmailUtils';
import PhoneUtils from '@/mixins/PhoneUtils';
import PasswordUtils from '@/mixins/PasswordUtils';
import DateUtils from '@/mixins/DateUtils';
import NotificationManager from '@/mixins/NotificationManager';
import EsLoader from '@/components/EsLoader.vue';

library.add(
  faBan,
  faCheck,
);
export default {
  components: {
    EsLoader,
  },
  mixins: [EmailUtils, PhoneUtils, PasswordUtils, DateUtils, NotificationManager],
  props: ['verificationKey'],
  data() {
    return {
      loading: false,
      step: 1,
      email: '',
      firstname: '',
      middlename: '',
      lastname: '',
      birthdate: '',
      gendercode: '',
      phone: '',
      password: '',
      checkPassword: '',
      messages: [],
      emailMsg: '',
      fnMsg: '',
      lnMsg: '',
      mnMsg: '',
      genMsg: '',
      bdMsg: '',
      phoneMsg: '',
      pwMsg: '',
      failedMsg: 'Rules failed: ',
      hasVerified: false,
      hasErrorEmail: false,
      hasErrorFirstName: false,
      hasErrorLastName: false,
      hasErrorMiddleName: false,
      hasErrorGenderCode: false,
      hasErrorBirthDate: false,
      hasErrorValidation: false,
      hasErrorPassword: false,
      hasErrorPhone: false,
      // message: '',
      formLogin: {
        email: '',
        firstName: '',
        middleName: null,
        lastName: '',
        dateOfBirth: '',
        phone1: null,
        password: '',
      },
      submitText: 'Create Account & Login',
      message: '',
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
      failed: [],
    };
  },
  mounted() {
    if (this.verificationKey) {
      this.verify();
    }
  },
  computed: {
    hasError() {
      return this.hasErrorEmail
      || this.hasErrorFirstName
      || this.hasErrorLastName
      || this.hasErrorMiddleName
      || this.hasErrorGenderCode
      || this.hasErrorBirthDate
      || this.hasErrorPhone
      || this.hasErrorValidation
      || this.hasErrorPassword;
    },
  },
  methods: {
    ...mapActions({
      verifyToken: 'verifyToken',
      verifyEmail: 'verifyEmail',
      signup: 'signup',
      initProperties: 'propertiesModule/init',
      initFields: 'fieldLabelsModule/init',
    }),
    async verify() {
      this.loading = true;
      try {
        await this.verifyToken(this.verificationKey).then((response) => {
          this.hasVerified = true;
        });
      } catch (error) {
        if (error.response.status === 500) {
          this.message = 'Network Error';
          this.showNotification('danger', [this.message]);
        }
      }
      finally {
        this.loading = false;
      }
    },
    validate(field) {
      let errors = 0;
      if (!field || field === 'email') {
        if (!this.email) {
          errors += 1;
          this.emailMsg = 'Email address is required.';
          this.hasErrorEmail = true;
        } else if (!this.isWelformed(this.email)) {
          errors += 1;
          this.emailMsg = 'Email address is invalid.';
          this.hasErrorEmail = true;
        } else {
          this.formLogin.email = this.email;
          this.hasErrorEmail = false;
        }
      }
      if (!field || field === 'firstname') {
        if (!this.firstname || this.firstname.trim().length === 0) {
          errors += 1;
          this.fnMsg = 'First Name is required.';
          this.hasErrorFirstName = true;
        } else if (this.firstname.trim().length > 60) {
          errors += 1;
          this.fnMsg = 'First Name is invalid.';
          this.hasErrorFirstName = true;
        } else {
          this.formLogin.firstName = this.firstname.trim();
          this.hasErrorFirstName = false;
        }
      }
      if (!field || field === 'middlename') {
        if (this.middlename && this.middlename.trim().length > 0) {
          if (this.middlename.trim().length > 20) {
            errors += 1;
            this.mnMsg = 'Middle Name is invalid.';
            this.hasErrorMiddleName = true;
          } else {
            this.formLogin.middleName = this.middlename.trim();
            this.hasErrorMiddleName = false;
          }
        }
      }
      if (!field || field === 'lastname') {
        if (!this.lastname || this.lastname.trim().length === 0) {
          errors += 1;
          this.lnMsg = 'Last Name is required.';
          this.hasErrorLastName = true;
        } else if (this.lastname.trim().length > 60) {
          errors += 1;
          this.lnMsg = 'Last Name is invalid.';
          this.hasErrorLastName = true;
        } else {
          this.formLogin.lastName = this.lastname.trim();
          this.hasErrorLastName = false;
        }
      }
      if (!field || field === 'birthdate') {
        if (this.birthdate && this.birthdate.trim().length > 0) {
          if (!this.isValidDateFormat(this.birthdate, 'YYYY-MM-DD')
            || !this.isValidDOB(this.birthdate, 'YYYY-MM-DD')) {
            errors += 1;
            this.bdMsg = 'Date of Birth is invalid.';
            this.hasErrorBirthDate = true;
          } else {
            const birthdate = this.getCorrectDateFromYYYYMMDDString(this.birthdate);
            const today = new Date().getTime();
            if (moment(birthdate).isAfter(today)) {
              errors += 1;
              this.hasErrorBirthDate = true;
              this.bdMsg = 'Date of Birth is invalid.';
            } else {
              this.formLogin.dateOfBirth = birthdate.getTime();
              this.hasErrorBirthDate = false;
            }
          }
        }
      }
      if (!field || field === 'phone') {
        if (this.phone) {
          if (!this.isValidPhone(this.phone)) {
            errors += 1;
            this.phoneMsg = 'Phone number is invalid.';
            this.hasErrorPhone = true;
          } else {
            this.formLogin.phone1 = this.phone;
            this.hasErrorPhone = false;
          }
        }
      }
      if (!field) {
        this.messages = [];
        if (errors !== 0) {
          this.messages.push(this.formErrorMsg);
          this.showNotification('danger', this.messages);
        } else {
          this.resetErrors();
        }
      }
      return errors === 0;
    },
    async nextStep() {
      const validtionSuccess = this.validate();
      if (!validtionSuccess) return;
      this.formLogin.verificationKey = this.verificationKey;
      try {
        await this.verifyEmail(this.formLogin);
        this.step = 2;
        this.hideNotification();
      } catch (error) {
        this.message = `${error.response.status === 500
          ? 'Network Error'
          : error.response.data.message}`;
        this.messages.push(this.message);
        this.showNotification('danger', this.messages);
      }
      window.scrollTo(0, 0);
    },
    async formSubmit() {
      let errors = 0;
      this.resetErrors();
      this.hideNotification();
      if (!this.password) {
        errors += 1;
        this.pwMsg = 'Password is required.';
        this.hasErrorPassword = true;
      } else if (!this.checkPasswordMatch()) {
        errors += 1;
        this.pwMsg = 'New Password and Verify Password do not match.';
        this.hasErrorPassword = true;
      }
      if (errors > 0) {
        this.messages.push(this.formErrorMsg);
        this.showNotification('danger', this.messages);
      } else {
        this.failed = this.rulesFailed(this.formLogin.email, this.password);
        if (this.failed.length > 0) {
          errors += 1;
          this.pwMsg = 'Password is invalid.';
          this.showNotification('danger', [this.formErrorMsg]);
          this.hasErrorPassword = true;
        }
      }
      if (errors === 0) {
        this.loading = true;
        this.formLogin.password = this.password;
        try {
          await this.signup(this.formLogin);
          await Promise.all([
            this.initProperties(),
            this.initFields(),
          ]);
          this.$router.push({ name: 'home' });
        } catch (error) {
          errors += 1;
          this.message = `${error.response.status === 500
            ? 'Network Error'
            : error.response.data.message}`;
          this.messages.push(this.message);
          this.showNotification('danger', this.messages);
        } finally {
          this.loading = false;
        }
        window.scrollTo(0, 0);
      }
    },
    checkPasswordMatch() {
      return this.password === this.checkPassword;
    },
    resetErrors() {
      this.messages = [];
      this.hasErrorEmail = false;
      this.hasErrorFirstName = false;
      this.hasErrorLastName = false;
      this.hasErrorMiddleName = false;
      this.hasErrorGenderCode = false;
      this.hasErrorBirthDate = false;
      this.hasErrorPhone = false;
      this.hasErrorValidation = false;
      this.hasErrorPassword = false;
      this.emailMsg = '';
      this.fnMsg = '';
      this.lnMsg = '';
      this.mnMsg = '';
      this.genMsg = '';
      this.bdMsg = '';
      this.phoneMsg = '';
      this.pwMsg = '';
      this.failed = [];
    },
    prevStep() {
      this.step = 1;
      window.scrollTo(0, 0);
    },
    ruleOk(rule) {
      let lookup;
      if (this.failed.length > 0) {
        lookup = this.failed
          .find(r => r.trim().toLowerCase() === rule.message.trim().toLowerCase());
      }
      return !lookup;
    },
  },
};
</script>

<style lang="sass" scoped>
  .reset-container-p4-round-white
    border-radius: 4.8px
    padding: 1.5rem !important
    background-color: white
    width: 348px
  .unstyled
    list-style-type: none
  .justify-content-center
    justify-content: center
  .padding-top
    padding-top: 1rem
  .no-result-container
    padding: 6.5rem
</style>
